import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DebugMenuComponent} from './debug-menu.component';
import {ChappsCommonAngularLibraryModule} from "@npm.chapps.com/chapps.common.angular.library";
import {EnvSelectorModule} from "../../../../environment/env-selector/env-selector.module";


@NgModule({
    declarations: [
        DebugMenuComponent
    ],
    exports: [
        DebugMenuComponent
    ],
    imports: [
        CommonModule,
        ChappsCommonAngularLibraryModule,
        EnvSelectorModule
    ]
})
export class DebugMenuModule {
}
